const VisitorCharacteristicsActionTypes = {
  SET_INITIALIZED: "visitorCharacteristics/SET_INITIALIZED",
  SET_LOADING: "visitorCharacteristics/SET_LOADING",
  SET_FILTERS: "visitorCharacteristics/SET_FILTERS",
  SET_FILTER: "visitorCharacteristics/SET_FILTER",
  SET_QUALIFICATION_INDICATORS_FILTERS:
    "visitorCharacteristics/SET_QUALIFICATION_INDICATORS_FILTERS",
  SET_QUALIFICATION_INDICATORS:
    "visitorCharacteristics/SET_QUALIFICATION_INDICATORS",
  SET_QUALIFICATION_VISITORS_FILTERS:
    "visitorCharacteristics/SET_QUALIFICATION_VISITORS_FILTERS",
  SET_QUALIFICATION_VISITORS:
    "visitorCharacteristics/SET_QUALIFICATION_VISITORS",
  SET_QUALIFICATION_TIME_FILTERS:
    "visitorCharacteristics/SET_QUALIFICATION_TIME_FILTERS",
  SET_QUALIFICATION_TIME: "visitorCharacteristics/SET_QUALIFICATION_TIME",
  SET_QUALIFICATION_DESTINATION_FILTERS:
    "visitorCharacteristics/SET_QUALIFICATION_DESTINATION_FILTERS",
  SET_QUALIFICATION_DESTINATION:
    "visitorCharacteristics/SET_QUALIFICATION_DESTINATION",
  SET_QUALIFICATION_CATCHMENT_AREAS_FILTERS:
    "visitorCharacteristics/SET_QUALIFICATION_CATCHMENT_AREAS_FILTERS",
  SET_QUALIFICATION_CATCHMENT_AREAS:
    "visitorCharacteristics/SET_QUALIFICATION_CATCHMENT_AREAS",
  SET_AUTO_REFRESH: "visitorCharacteristics/SET_AUTO_REFRESH",
};

export default VisitorCharacteristicsActionTypes;
